import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { TabsGroup } from "@unified-checkout/design-system";

import type { TNavTabs } from "@app/dashboard/types/innerLayout/checkout_customization";
import { NAVIGATION_TABS } from "../../utils";
import styles from "./navigation-tabs.module.scss";


export const NavigationTabs = ({
  setActiveTab,
  activeTab
}: {
  setActiveTab: Dispatch<SetStateAction<TNavTabs>>,
  activeTab: TNavTabs
}) => {
  const { t } = useTranslation();

  const tabsProps = [
    {
      tabName: NAVIGATION_TABS.BRANDING,
      tabLabel: t('innerLayout.checkoutCustomizationPage.tabs.branding.title'),
    },
    {
      tabName: NAVIGATION_TABS.PAYMENT,
      tabLabel: t('innerLayout.checkoutCustomizationPage.tabs.payment.title'),
    },
    {
      tabName: NAVIGATION_TABS.POST_PAYMENT,
      tabLabel: t('innerLayout.checkoutCustomizationPage.tabs.postPayment.title'),
    },
  ];

  return (
    <div className={styles["navigation-tabs"]}>
      <TabsGroup
        orientation="horizontal"
        tabsProps={tabsProps.map((tab) => ({
          ...tab,
          active: activeTab === tab.tabName,
          onClickHandler: (tabLabel?: string, tabName?: string) => {
            setActiveTab(tab.tabName);
          }
        }))}
      />
    </div>
  )
};